import { Link } from 'react-router';

export default function NotFound() {
    return (
        <div
            style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                minHeight: '100vh',
                padding: '1.5rem',
                textAlign: 'center',
            }}
        >
            <h1 style={{ fontSize: '1.5rem', fontWeight: 600, marginBottom: '0.5rem' }}>Page not found</h1>
            <p style={{ color: 'var(--gray-11)', marginBottom: '1.5rem' }}>The page you're looking for doesn't exist or has been moved.</p>
            <Link
                to="/books"
                style={{ color: 'var(--accent-11)', textDecoration: 'underline' }}
            >
                Go to home
            </Link>
        </div>
    );
}
